module.exports = __webpack_public_path__ + "img/about-hero.3bf4e787.jpg";